import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import DataDrivenLogo from '../../../../../components/data-driven-logo';
import GetInsuranceProviderDisplayName from '../../../../../components/data-driven-logo/get-insurance-provider-display-name';

import FormattedCurrency from '../../../../../components/formatted-currency/container';
import useSellerInsuranceProvider from '../hooks/use-seller-insurance-provider';
import { useTrackEvent, PageEvents } from '../hooks/use-track-event';

import style from './style.module.less';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

const SellerInsuranceProviderRow = ({ sellerInsuranceProviderId, initiateAddFunds, isLoading }) => {
  const trackEvent = useTrackEvent(PageEvents.FUND_SHIPSURANCE_CLICK);
  // Note: This is a static approach for Shipsurance.
  // This can be expanded once we support multiple insurance providers
  const addFunds = useCallback(() => {
    initiateAddFunds(sellerInsuranceProviderId);
    trackEvent();
  }, [initiateAddFunds, sellerInsuranceProviderId, trackEvent]);

  const sellerInsuranceProvider = useSellerInsuranceProvider(sellerInsuranceProviderId);
  const insuranceProviderMessageDescriptor = GetInsuranceProviderDisplayName(sellerInsuranceProvider?.insuranceProviderId);

  if (!sellerInsuranceProvider) {
    return null;
  }

  const { balance } = sellerInsuranceProvider;
  return (
    <>
      <div className={classNames(style.cell, style['insurance-provider-name'])}>
        <div className={style['insurance-provider-row-icon']}>
          <DataDrivenLogo insuranceProviderId={sellerInsuranceProvider?.insuranceProviderId} />
        </div>
        <div>
          <FormattedMessage {...insuranceProviderMessageDescriptor} />
        </div>
      </div>
      <div className={style.cell}>
        {balance && <FormattedCurrency currencyCode={balance.code} value={balance.value} />}
        {isLoading && <LoadingIndicator className={style.loading} />}
      </div>
      <div className={style.cell}>
        <div className={style.action} onClick={addFunds}>
          <FormattedMessage defaultMessage='Add Funds' description='Insurance provider row add funds button' id='1KryqS' />
        </div>
      </div>
    </>
  );
};

SellerInsuranceProviderRow.propTypes = {
  sellerInsuranceProviderId: PropTypes.string.isRequired,
  initiateAddFunds: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default SellerInsuranceProviderRow;
